import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class CertificadosNacionaisService extends Service{

  protected url: string = this.dominio+"/adm/certificados-nacionais/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  // envia a ficha para o cliente por email
  enviarCertificadoParaCliente(id){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id +'/notificar', {},{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  setStatus(id_ficha, id_status, notificaEmail = true){

    let headers = this.getHeaderLogado();
    let url = (notificaEmail) ? this.dominio+"/adm/fichas/"+id_ficha+"/status/"+id_status+"/" : this.dominio+"/adm/fichas/"+id_ficha+"/status/"+id_status+"/nao-notifica";


    return this.http
      .put(
        url, {},
        { headers }
      )
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  getStatus(){
      let headers = this.getHeaderLogado();

      return this.http.get(this.url+'status', {headers})
        .map(res => {
          let json = res.json();
          if(json.Success){
            this.trataSucesso(res);
          }else{
            this.trataErro(json);
          }
          return json;
        });

  }

  // solicita o envio da fatura por email
  enviaCertificadoEmail(id_ficha, elem){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id_ficha+'/notificar-com-email', JSON.stringify(elem),{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });

  }

  // emiti o certificados [id_certificado,id_certificado]
  emitirCertificados(certificados){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url +'emitir-massa', {"certificados": certificados},{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  emitirCertificadosSemNotificar(certificados){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url +'emitir-massa-sem-notificar', {"certificados": certificados},{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  baixarZIP(id_certificado){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id_certificado + '/download-zip', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });

  }

  assinarCertificado(id_certificado){

    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id_certificado + '/assinar', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/certificados-nacionais.service.ts